// ═══════════════════════════════════════════════════════════════════════════
// Módulo Tienda Nube — vertical del segundo canal (F2-T2, ADR 2026-08-16)
// ═══════════════════════════════════════════════════════════════════════════
// Multi-tenant como todos: el PLAN decide qué empresa lo tiene
// (modulosIncluidos → modulosDisponibles), y con el módulo en el plan la card
// de Integraciones de esa empresa se enciende (conectar por botón y por link).
// El id CALCA el de la plataforma ('tienda-nube') a propósito: es la llave con
// la que Integraciones gatea la card contra empresa.modulosDisponibles.
//
// Conectar/desconectar usa el permiso agnóstico 'integraciones';
// 'tienda-nube' (catálogo, slug canónico único del ADR 13-ago) gatea los
// dashboards de F2-T3 (registro en ./registry.js, lista blanca con test).

import { lazy } from 'react'
import { DASHBOARDS_TN, DASHBOARDS_TN_PLANEADOS } from './registry'
import { AJUSTES_CONEXION_TN } from './lib/ajustesConexionTn'
import { DATOS_CONEXION_TN } from './lib/datosConexionTn'

const InstalarPage = lazy(() => import('./pages/InstalarPage'))
// Pedidos de privacidad (24-sep-2026): el dueño baja el archivo que pidió un comprador (link del mail).
const PrivacidadPage = lazy(() => import('./pages/PrivacidadPage'))

export default {
  id: 'tienda-nube',
  nombre: 'Tienda Nube',
  descripcion: 'Integración con Tienda Nube: órdenes y publicaciones sincronizadas al modelo canónico',
  icono: 'shopping-bag',
  tipo: 'marketplace',
  version: '1.0.0',

  // El OAuth reusa las rutas plataforma-agnósticas del módulo mercadolibre
  // (conexion-resultado / conectar/:token) hasta que T1 las mueva al agregador
  // neutro (deuda declarada en el ADR). La ÚNICA ruta propia es la del alta
  // self-service, que no es del OAuth: es la pantalla a la que Tienda Nube
  // manda al vendedor después de instalar desde su App Store.
  //
  // `public: true` NO es cosmético: las rutas públicas se registran siempre,
  // con sesión o sin ella (`App.jsx`), y quien abre este link todavía no es
  // usuario de la app — sin eso terminaría redirigido a /login y el ticket se
  // perdería. Y el path va SIN barra inicial, como todas las rutas de módulo.
  routes: [
    { path: 'instalar', component: InstalarPage, public: true },
    // Privada (con sesión). El path lleva el módulo porque App.jsx monta las rutas
    // SIN prefijo: 'privacidad' a secas sería /privacidad. Es el link del mail.
    // `enPortal: true` (25-sep-2026, prueba con Mariano): la pantalla es del
    // DUEÑO, que es un CLIENTE — sin esto el link del mail lo mandaba a /portal
    // y la pantalla era inalcanzable justo para el único que la puede usar.
    // Con esto el cliente que abre /tienda-nube/privacidad cae en su gemela
    // /portal/tienda-nube/privacidad (App.jsx, `destinoDeCliente`). Su ítem de
    // menú vive en el del portal (`portal/PortalLayout.jsx`), no en `menuItems`.
    { path: 'tienda-nube/privacidad', enPortal: true, component: PrivacidadPage },
  ],
  menuItems: [],

  // Declaración que junta el agregador neutro (core/lib/dashboardsRegistro,
  // T1). Misma constante que deriva `vistasEmpresa` — una fuente, dos
  // proyecciones (calco del molde ML).
  dashboards: DASHBOARDS_TN,
  // Tarjetas de lo que falta construir (sin pantalla, sin nodo de vistas): las
  // junta `getDashboardsPlaneados` del agregador neutro.
  dashboardsPlaneados: DASHBOARDS_TN_PLANEADOS,

  // Lo que el vendedor carga a mano de su conexión y la API no expone (ADR
  // 2026-09-14, tarifas TN): hoy el plazo de acreditación de Pago Nube. Lo
  // junta el agregador neutro `core/lib/ajustesConexionRegistro`; el servidor
  // valida con el vocabulario del adapter del canal.
  ajustesConexion: AJUSTES_CONEXION_TN,
  // Lo que se MUESTRA de la conexión, sólo leer (30-sep-2026): el plan de la
  // tienda, arriba de sus dashboards. Lo junta `getDatosConexion`.
  datosConexion: DATOS_CONEXION_TN,

  // Vistas gateables (F2-T3): el NODO DEL TAB 'dash-tienda-nube' + una card
  // por dashboard, bajo el grupo propio 'dashboards-tn'. El tab se declara
  // acá porque la excepción de EmpresaDetailPage:207 cubre SOLO el grupo ML
  // ('dashboards'); el grupo TN se gatea entero desde Vista detallada —
  // toggle de grupo real, que es lo que pidió Mariano (F2). Sin bypass de
  // staff (decisión 7-jul): nace apagado para TODOS hasta que se tilde.
  vistasEmpresa: [
    {
      id: 'dash-tienda-nube',
      label: 'Tiendanube (tab)',
      grupo: 'dashboards-tn',
      grupoLabel: 'Dash Tienda Nube',
      grupoOrden: 6,
      orden: -1,
    },
    ...DASHBOARDS_TN.map(d => ({
      id: d.id,
      label: d.nombre,
      grupo: 'dashboards-tn',
      grupoLabel: 'Dash Tienda Nube',
      grupoOrden: 6,
      orden: d.orden ?? 99,
    })),
  ],

  features: [],
  permisoModulos: ['integraciones', 'tienda-nube'],
}
